import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';

import { cloneDeep, each, findIndex } from 'lodash';

@Component({
  selector: 'app-select-multiple',
  templateUrl: './select-multiple.component.html',
  styleUrls: ['./select-multiple.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SelectMultipleComponent implements OnInit, OnChanges {
  public isAllItemsShow = true;
  public isAllItemsChecked = false;
  public itemsClone = null;
  public checkedItems = 0;
  public searchText: string;

  @Input() items;
  @Output() callback = new EventEmitter<any>();
  @Input() textKey;
  @Input() initBy;
  @Input() initByKey;
  @Input() defaultText;
  @Input() isDisabled;
  @Input() name;

  constructor() {}

  ngOnInit() {
    this.defaultText = this.defaultText || 'Выберите значение';
    this.itemsClone = cloneDeep(this.items);
    this.initCheckedItems();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes && changes.items) || (changes && changes.initBy)) {
      this.itemsClone = cloneDeep(this.items);
      this.initCheckedItems();
    }
  }

  private initCheckedItems(): void {
    const items = this.itemsClone;
    const initKey = this.initByKey;
    const initBy = this.initBy;

    if (!items) {
      return;
    }

    each(items, (item) => {
      if (initBy && initKey) {
        const itemIndex = findIndex(initBy, (i) => i[initKey] === item[initKey]);

        item.checked = itemIndex > -1;
      } else {
        item.checked = false;
      }
    });

    this.checkedItems = this.itemsClone.filter((item) => item.checked).length;
    this.isAllItemsChecked = !!this.itemsClone.length && this.checkedItems === this.itemsClone.length;
  }

  public toggleItemsShow(): void {
    this.isAllItemsShow = !this.isAllItemsShow;
  }

  public toggleItemsChecked(): void {
    this.isAllItemsChecked = !this.isAllItemsChecked;

    each(this.itemsClone, (item) => {
      item.checked = this.isAllItemsChecked;
    });

    this.applyCallback();
  }

  public changeInversion(): void {
    each(this.itemsClone, (item) => {
      item.checked = !item.checked;
    });

    this.applyCallback();
  }

  public onChangeCheckedItem(event, item): void {
    item.checked = event;

    this.applyCallback();
  }

  public onOpenChange(isOpen): void {
    if (!isOpen) {
      this.searchText = null;
      this.isAllItemsShow = true;
    }
  }

  private applyCallback(): void {
    const items = cloneDeep(this.itemsClone.filter((item) => item.checked));

    this.checkedItems = items.length;
    this.callback.emit(
      items.map(({ checked, ...item }) => item)
    );
  }
}
